import React, { useContext } from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { SubmitHandler, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Swal from 'sweetalert2'
import JWTContext from '../../context/JWTContext';
import { useGoogleLogin } from '@react-oauth/google';
import axios from 'axios';

const schema = yup.object({
    username: yup.string().required(),
    password: yup.string().min(6).required(),
    rememberMe: yup.boolean(),
}).required();

const LoginForm = () => {
    const navigate = useNavigate();
    const [isShowPassword, setIsShowPassword] = React.useState(false);
    const [isMobile, setIsMobile] = React.useState(() => {
        if (typeof window === 'undefined') return false;
        return window.innerWidth <= 575;
    });
    const location = useLocation();

    const params = new URLSearchParams(location.search);
    const redirectPath = params.get('redirect') || '/';

    const { login: loginAccount, loginWithGoogle } = useContext(JWTContext);

    const {
        register,
        handleSubmit,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(schema)
    });

    const onSubmit = async (data) => {
        try {
            const result = await loginAccount({
                username: data.username,
                password: data.password,
                rememberMe: data.rememberMe
            });
            //console.log(result);
            // Swal.fire({
            //     title: "Success",
            //     text: "Login successfully",
            //     icon: "success"
            // });
            navigate(redirectPath, { replace: true });
        } catch (err) {
            //console.log(err);
            Swal.fire({
                title: "Error",
                text: err.message,
                icon: "error"
            });
        }
    };

    const googleLogin = useGoogleLogin({
        onSuccess: async (tokenResponse) => {
            try {
                const { code, state } = tokenResponse;
                // Exchange code for access token
                const tokenExchangeResponse = await axios.post('https://oauth2.googleapis.com/token', {
                    code,
                    client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID, // Replace with your Client ID
                    client_secret: process.env.REACT_APP_GOOGLE_CLIENT_SECRET, // Replace with your Client Secret
                    redirect_uri: window.location.origin,
                    grant_type: 'authorization_code',
                });
                const { id_token } = tokenExchangeResponse.data;
                await loginWithGoogle(id_token); // Pass to JWTContext
                navigate(redirectPath, { replace: true });
            } catch (err) {
                Swal.fire({
                    title: 'Error',
                    text: 'Google login failed. Please try again later.',
                    icon: 'error',
                });
            }
        },
        onError: () => {
            Swal.fire({
                title: 'Error',
                text: 'Google login failed. Please try again later.',
                icon: 'error',
            });
        },
        flow: 'auth-code', // Use authorization code flow to get access token
        redirect_uri: window.location.origin, // Must match Google Cloud Console
        scope: 'openid profile email', // Adjust scopes as needed
    });

    React.useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 575);
        };

        handleResize();
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <section
            className='d-flex position-relative align-items-center py-4 bg-main-one-600 h-100'
            style={{ minHeight: '100vh', paddingLeft: isMobile ? '12px' : '', paddingRight: isMobile ? '12px' : '' }}
        >
            <img
                src="assets/images/shape/offer-shape.png"
                alt=""
                className="position-absolute inset-block-start-0 inset-inline-start-0 w-100 h-100 opacity-6"
            />
            <div className='authForm' style={isMobile ? { width: '100%' } : {}}>
                <div className='d-flex justify-content-center mb-48'>
                    <a href="/" className='d-flex justify-content-center'>
                        {/* <img
                            src='assets/images/logo/logo-iWant-Asia.png' //harusnya warna putih
                            alt='Logo'
                            className="formLogo"
                            style={{filter: "brightness(0) invert(1)"}}
                        /> */}
                        <span className='text-white text-36'>i WANT Customer Login</span>
                       
                    </a>
                </div>

                <form
                    onSubmit={handleSubmit(onSubmit)}
                    className="border border-white-100 bg-white transition-1 rounded-16 px-24 py-40 h-100"
                    style={isMobile ? { paddingLeft: '16px', paddingRight: '16px', paddingTop: '28px', paddingBottom: '28px' } : {}}
                >
                    <h6 className="text-3xl text-center text-main-one-600 mb-32">Login</h6>
                    <div className="mb-24">
                        {/* <label
                            htmlFor="username"
                            className="text-neutral-900 text-lg mb-8 fw-medium"
                        >
                            Phone or email address <span className="text-danger">*</span>{" "}
                        </label> */}
                        <input
                            type="text"
                            className="common-input"
                            {...register("username")}
                            // placeholder="Enter Username"
                            placeholder="Enter Email Address"
                        />
                    </div>
                    <div className="mb-10">
                        {/* <label
                            htmlFor="password"
                            className="text-neutral-900 text-lg mb-8 fw-medium"
                        >
                            Password
                        </label> */}
                        <div className="position-relative">
                            <input
                                type={isShowPassword ? 'text' : 'password'}
                                className="inputPassword"
                                {...register("password")}
                                placeholder="Enter Password"
                            //defaultValue="password"
                            />
                            <span
                                className={`toggle-password position-absolute top-50 inset-inline-end-0 me-16 translate-middle-y cursor-pointer ph ${isShowPassword ? 'ph-eye' : 'ph-eye-slash'}`}
                                onClick={() => setIsShowPassword(!isShowPassword)}
                            />
                        </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="form-check common-check">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                defaultValue=""
                                {...register("rememberMe")}
                            />
                            <label
                                className="form-check-label flex-grow-1"
                                htmlFor="remember"
                            >
                                Remember me
                            </label>
                        </div>
                        {/* <Link
                            to="#"
                            className="text-danger-600 text-sm fw-semibold hover-text-decoration-underline"
                        >
                            Forgot password?
                        </Link> */}
                    </div>
                    <div className="mb-24 mt-48">
                        <div className="flex-align gap-48 flex-wrap mb-24">
                            <button type="submit" className="btn btn-main-one w-100 rounded-pill py-15 px-40">
                                Login
                            </button>

                        </div>
                        <div className="flex-align gap-48 flex-wrap mb-20 d-none">
                            <h4 className='text-center w-100 text-sm fw-medium'>or continue with</h4>
                        </div>
                        <div className="flex-align gap-48 flex-wrap mb-24 d-none">
                            <button type="button" onClick={() => googleLogin()} className="btn btn-white border border-main-one-600 hover-border-main-one-600 w-100 rounded-pill py-12 px-40">
                                <img
                                    src='assets/images/social/google.png'
                                    alt='Logo'
                                    className="w-20 h-20"
                                />
                            </button>
                        </div>
                        <div className="flex-align gap-48 flex-wrap mb-20">
                            <h4 className='text-center w-100 text-sm fw-medium'>Don’t have an account yet? <Link to={`/register?redirect=${encodeURIComponent(redirectPath)}`} className='text-main-one-600'>Register</Link></h4>
                        </div>
                    </div>

                </form>
            </div>
        </section>
    )
}

export default LoginForm